<template>
  <div class="sales-items-table">
    <v-simple-table
      fixed-header
    >
      <template v-slot:default>
        <thead>
          <tr>
            <th>Vara</th>
            <th>Antal</th>
            <th>Pris</th>
            <th>Total</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="salesItem in salesItems"
            :key="salesItem.id"
          >
            <td>
              <div :class="{ 'pt-2': !!salesItem.product_description }">
                <v-chip
                  :color="salesItem.product.gui_color"
                  dark
                >
                  {{ salesItem.product_name }}
                </v-chip>
              </div>
              <div v-show="!!salesItem.product_description" class="pb-2 pt-1 pl-3 text-caption">
                {{ salesItem.product_description }}
              </div>
            </td>

            <td>
              {{ salesItem.quantity / 1000 }}
            </td>

            <td>
              <template v-if="salesItem.discount_type === null || salesItem.original_price === 0">
                {{ toHumanReadableAmount(salesItem.price) }}
              </template>
              <template v-else-if="salesItem.discount_type === 'fixed'">
                <div>
                  <span class="text-decoration-line-through">
                    {{ toHumanReadableAmount(salesItem.original_price) }}
                  </span>
                  <span class="red--text ml-2">
                    {{ toHumanReadableAmount(salesItem.price) }}
                  </span>
                </div>
                <div>
                  <i>Rabatt: {{ toHumanReadableAmount(salesItem.original_price - salesItem.price) }}</i>
                </div>
              </template>
              <template v-else-if="salesItem.discount_type === 'flat'">
                <div>
                  <span class="text-decoration-line-through">
                    {{ toHumanReadableAmount(salesItem.original_price) }}
                  </span>
                  <span class="red--text ml-2">
                    {{ toHumanReadableAmount(salesItem.price) }}
                  </span>
                </div>
                <div>
                  <i>Rabatt: {{ toHumanReadableAmount(salesItem.discount_value) }}</i>
                </div>
              </template>
              <template v-else-if="salesItem.discount_type === 'percent'">
                <div>
                  <span class="text-decoration-line-through">
                    {{ toHumanReadableAmount(salesItem.original_price) }}
                  </span>
                  <span class="red--text ml-2">
                    {{ toHumanReadableAmount(salesItem.price) }}
                  </span>
                </div>
                <div class="font-italic">
                  Rabatt: {{ salesItem.discount_value / 100 }}%
                </div>
              </template>
              <div v-if="salesItem.discount_type && salesItem.discount_name" class="font-italic">{{ salesItem.discount_name }}</div>
            </td>

            <td>
              {{ toHumanReadableAmount(salesItem.sale) }}
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
import { toHumanReadableAmount } from '@/plugins/conversion'

export default {
  name: 'SalesItemsTable',
  props: {
    salesItems: Array
  },
  data: () => ({}),
  methods: {
    toHumanReadableAmount: function (amount) {
      return window.conversion.toHumanReadableAmount(amount / 100)
    }
  }
}
</script>
